import { render, staticRenderFns } from "./AppTemplateApply.vue?vue&type=template&id=2ad647be&scoped=true"
import script from "./AppTemplateApply.vue?vue&type=script&lang=js"
export * from "./AppTemplateApply.vue?vue&type=script&lang=js"
import style0 from "./AppTemplateApply.vue?vue&type=style&index=0&id=2ad647be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad647be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ad647be')) {
      api.createRecord('2ad647be', component.options)
    } else {
      api.reload('2ad647be', component.options)
    }
    module.hot.accept("./AppTemplateApply.vue?vue&type=template&id=2ad647be&scoped=true", function () {
      api.rerender('2ad647be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/appTemplate/component/AppTemplateApply.vue"
export default component.exports